import { IServerSentEventsConsumerFactory } from '../../../infra';
import { IConversationRun } from '../model/ConversationRun';
import { IPlacerAssistantFactory } from '../model/PlacerAssistantFactory';
import { IPlacerAssistantService } from './PlacerAssistantService';
import { IRunLifecycleManager, RunLifecycleManager } from './RunLifecycleManager';

export interface IRunLifecycleManagerFactory {
    create(run: IConversationRun): IRunLifecycleManager;
}

export class RunLifecycleManagerFactory implements IRunLifecycleManagerFactory {
    constructor(
        private placerAssistantFactory: IPlacerAssistantFactory,
        private serverSentEventsFactory: IServerSentEventsConsumerFactory,
        private assistantService: IPlacerAssistantService,
    ) {}

    create(run: IConversationRun): IRunLifecycleManager {
        const conversationId = run.conversationId.get();
        const runId = run.getId();
        const path = `v1/conversations/${conversationId}/runs/${runId}/stream`;
        const consumer = this.serverSentEventsFactory.createServerSentEventsConsumer(path);

        return new RunLifecycleManager(
            run,
            this.placerAssistantFactory,
            consumer,
            this.assistantService,
        );
    }
}
